import { oauthAPI } from "./api";

export async function oauth ({ data }) {
    
    const env = this.env;
   
   
    const res = await oauthAPI({
        store: this,
        body: {
            ...data
        },
        traceId: env.traceId,
    });

    if (!res.error) {
        console.log('oauth success !' , res.data);
        this.updateAuthInfo({
            token: res.data.idToken.jwtToken,
            payload: res.data.idToken.payload,
            refreshToken: res.data.refreshToken.token,
        });
    
    } else {
        
    }
}

export default oauth;
